module.exports = __webpack_public_path__ + "img/mint-left-storm.cf647539.svg";